// CRM section test ids (docs/crm-module/crm-frontend-design.md §E). Convention:
// `crm-<screen>-<element>[-<id>]`, screen ∈ dash today nudge perf setup clients
// add-client client import book assign-pack forms email seq broadcast packs.

export const CRM = Object.freeze({
  shell: "crm-shell",

  // Dashboard
  dash: "crm-dash",
  dashContactLookup: "crm-dash-contact-lookup",
  setupBanner: "crm-setup-banner",
  setupBannerWelcome: "crm-setup-banner-welcome",
  setupBannerReminders: "crm-setup-banner-reminders",
  setupBannerDismiss: "crm-setup-banner-dismiss",
  setup: "crm-setup",
  setupCard: (key) => `crm-setup-card-${key}`, // import | add | reminders
  setupCardDone: (key) => `crm-setup-card-${key}-done`,
  setupRemindersTooltip: "crm-setup-card-reminders-tooltip",
  today: "crm-today",
  todayCount: "crm-today-count",
  todayEmpty: "crm-today-empty",
  todayError: "crm-today-error",
  todayCard: (bookingId) => `crm-today-card-${bookingId}`,
  todayAttendee: (bookingId) => `crm-today-attendee-${bookingId}`,
  todayOpen: (bookingId) => `crm-today-open-${bookingId}`,
  todayNew: (bookingId) => `crm-today-new-${bookingId}`,
  todayConfirm: (bookingId) => `crm-today-confirm-${bookingId}`,
  todayRemindersOffTooltip: "crm-today-reminders-off-tooltip",
  todayComplete: (bookingId) => `crm-today-complete-${bookingId}`,
  todayNoShow: (bookingId) => `crm-today-noshow-${bookingId}`,
  todayAttendance: (bookingId) => `crm-today-attendance-${bookingId}`,
  todayNotePrompt: "crm-today-note-prompt",
  todayNoteText: "crm-today-note-input",
  todayNoteSave: "crm-today-note-save",
  todayNoteLater: "crm-today-note-later",
  nudgeList: "crm-nudge-list",
  nudgeShowAll: "crm-nudge-show-all",
  nudgeEmpty: "crm-nudge-empty",
  nudgePager: "crm-nudge-pager",
  nudge: (id) => `crm-nudge-${id}`,
  nudgeAct: (id) => `crm-nudge-${id}-act`,
  nudgeDismiss: (id) => `crm-nudge-${id}-dismiss`,
  nudgeDialog: "crm-nudge-dialog",
  nudgeSend: "crm-nudge-send",
  perf: "crm-perf",
  perfPeriod: "crm-perf-period",
  perfFrom: "crm-perf-from",
  perfTo: "crm-perf-to",
  perfExport: "crm-perf-export",
  perfError: "crm-perf-error",
  perfMetric: (key) => `crm-perf-metric-${key}`,
  perfSales: "crm-perf-sales",
  perfSplit: "crm-perf-split",
  perfTop: "crm-perf-top",
  perfTopRow: (i) => `crm-perf-top-${i}`,
  perfPromos: "crm-perf-promos",
  perfPromoStop: (id) => `crm-perf-promo-stop-${id}`,
  perfPromoStopConfirm: "crm-perf-promo-stop-confirm",

  // Clients
  clients: "crm-clients",
  clientsSearch: "crm-clients-search",
  clientsViews: "crm-clients-views",
  clientsView: (id) => `crm-clients-view-${id}`,
  clientsViewSave: "crm-clients-view-save",
  clientsViewName: "crm-clients-view-name",
  clientsViewConfirm: "crm-clients-view-save-confirm",
  clientsImport: "crm-clients-import",
  clientsExport: "crm-clients-export",
  clientsAdd: "crm-clients-add",
  clientsFilter: (key) => `crm-clients-filter-${key}`,
  clientsFilterOption: (key, value) => `crm-clients-filter-${key}-option-${value}`,
  clientsClear: "crm-clients-clear",
  clientsImportBanner: "crm-clients-import-banner",
  clientsImportSkipped: "crm-clients-import-banner-download",
  clientsImportDismiss: "crm-clients-import-dismiss",
  clientsTable: "crm-clients-table",
  clientsRow: (id) => `crm-clients-row-${id}`,
  clientsRowDelete: (id) => `crm-clients-row-delete-${id}`,
  clientsCheck: (id) => `crm-clients-check-${id}`,
  clientsCheckAll: "crm-clients-check-all",
  clientsSelectMatching: "crm-clients-select-all-matching",
  clientsBulkCount: "crm-clients-bulk-count",
  clientsSort: (key) => `crm-clients-sort-${key}`,
  clientsBulk: "crm-clients-bulk",
  clientsBulkAction: (action) => `crm-clients-bulk-${action}`,
  clientsBulkClear: "crm-clients-bulk-clear",
  clientsBulkDialog: "crm-clients-bulk-dialog",
  clientsBulkConfirm: "crm-clients-bulk-confirm",
  clientsBulkTagInput: "crm-clients-bulk-tag-input",
  clientsBulkTagConfirm: "crm-clients-bulk-tag-confirm",
  clientsBulkDeleteDialog: "crm-clients-bulk-delete-dialog",
  clientsBulkDeleteInput: "crm-clients-bulk-delete-input",
  clientsBulkDeleteConfirm: "crm-clients-bulk-delete-confirm",
  clientsBulkDeleteError: "crm-clients-bulk-delete-error",
  clientsPager: "crm-clients-pager",
  clientsEmpty: "crm-clients-empty",
  clientsEmptyFiltered: "crm-clients-empty-filtered",
  clientsError: "crm-clients-error",
  addClient: "crm-add-client",
  addClientField: (key) => `crm-add-client-${key}`, // name email phone birthday-day birthday-month tags stage
  addClientExists: "crm-add-client-exists",
  addClientOpenRecord: "crm-add-client-open-record",
  addClientSave: "crm-add-client-save",

  // Client detail
  client: "crm-client",
  clientError: "crm-client-error",
  clientErased: "crm-client-erased",
  clientName: "crm-client-name",
  clientStage: "crm-client-stage",
  clientStageOption: (stage) => `crm-client-stage-option-${stage}`,
  clientStageResume: "crm-client-stage-resume",
  clientField: (key) => `crm-client-field-${key}`, // email phone birthday
  clientTags: "crm-client-tags",
  clientBook: "crm-client-book",
  clientLog: "crm-client-log",
  clientLogType: (type) => `crm-client-log-${type}`,
  clientLogDate: "crm-client-log-date",
  clientLogSummary: "crm-client-log-summary",
  clientLogSave: "crm-client-log-save",
  // crm-module BEGIN C3.02/C3.03 (lane F5) — meeting start/end time + the calendar-sync
  // indicator shown after a meeting is logged.
  clientLogStartTime: "crm-client-log-start-time",
  clientLogEndTime: "crm-client-log-end-time",
  clientLogTimeError: "crm-client-log-time-error",
  clientLogCalendarStatus: "crm-client-log-calendar-status",
  clientLogDone: "crm-client-log-done",
  // crm-module END
  clientSendEmail: "crm-client-send-email",
  clientSendEmailTooltip: "crm-client-send-email-tooltip",
  clientEmailDialog: "crm-client-email-dialog",
  clientEmailSubject: "crm-client-email-subject",
  clientEmailBody: "crm-client-email-body",
  clientEmailSend: "crm-client-email-send",
  clientMore: "crm-client-more",
  clientMoreItem: (key) => `crm-client-more-${key}`, // merge unsubscribe erase delete
  clientMerge: "crm-client-merge",
  clientMergeSearch: "crm-client-merge-search",
  clientMergeCandidate: (id) => `crm-client-merge-candidate-${id}`,
  clientMergeConfirm: "crm-client-merge-confirm",
  clientErase: "crm-client-erase",
  clientEraseInput: "crm-client-erase-input",
  clientEraseConfirm: "crm-client-erase-confirm",
  clientDelete: "crm-client-delete",
  clientDeleteConfirm: "crm-client-delete-confirm",
  clientUnsubscribe: "crm-client-unsubscribe",
  clientUnsubscribeConfirm: "crm-client-unsubscribe-confirm",
  clientSummary: (key) => `crm-client-summary-${key}`,
  assignPack: "crm-assign-pack",
  assignPackDialog: "crm-assign-pack-dialog",
  assignPackEmpty: "crm-assign-pack-empty",
  assignPackSelect: "crm-assign-pack-select",
  assignPackSubmit: "crm-assign-pack-submit",
  clientConsent: "crm-client-consent",
  clientDataExport: "crm-client-data-export",
  clientTab: (key) => `crm-client-tab-${key}`,
  clientTimelineFilter: (kind) => `crm-client-timeline-filter-${kind}`,
  clientTimelineItem: (id) => `crm-client-timeline-item-${id}`,
  clientTimelineMore: "crm-client-timeline-more",
  clientSession: (id) => `crm-client-session-${id}`,
  clientNotesHidden: "crm-client-notes-hidden",
  clientPackMinus: "crm-client-pack-minus",
  clientPackPlus: "crm-client-pack-plus",
  clientPackAdjustNote: "crm-client-pack-adjust-note",
  clientPackVoid: "crm-client-pack-void",
  clientPackVoidDialog: "crm-client-pack-void-dialog",
  clientPackVoidNote: "crm-client-pack-void-note",
  clientPackVoidConfirm: "crm-client-pack-void-confirm",
  clientNoteEditor: "crm-client-note-editor",
  clientNoteSession: "crm-client-note-session",
  clientNoteSave: "crm-client-note-save",
  clientIntake: "crm-client-intake",
  clientPurchase: (id) => `crm-client-purchase-${id}`,
  clientEmail: (id) => `crm-client-email-${id}`,
  clientEmailView: "crm-client-email-view",
  clientGeneralNotes: "crm-client-general-notes",
  clientGeneralNoteInput: "crm-client-general-note-input",
  clientGeneralNoteAdd: "crm-client-general-note-add",
  clientGeneralNote: (id) => `crm-client-general-note-${id}`,
  clientDocuments: "crm-client-documents",
  clientDocumentUpload: "crm-client-document-upload",
  clientDocument: (id) => `crm-client-document-${id}`,
  clientLinks: "crm-client-links",
  clientLinkAdd: (kind) => `crm-client-link-add-${kind}`,
  clientLink: (id) => `crm-client-link-${id}`,
  clientLinkPicker: "crm-client-link-picker",

  // Book session
  book: "crm-book",
  bookService: "crm-book-service",
  bookMode: "crm-book-mode",
  bookDay: (day) => `crm-book-day-${day}`,
  bookSlot: (i) => `crm-book-slot-${i}`, // carries data-start=<ISO start>
  bookNoSlots: "crm-book-no-slots",
  bookSubmit: "crm-book-submit",

  // Import wizard
  import: "crm-import",
  importStep: (n) => `crm-import-step-${n}`,
  importNext: "crm-import-next",
  importBack: "crm-import-back",
  importDropzone: "crm-import-dropzone",
  importFile: "crm-import-file",
  importDetected: "crm-import-detected",
  importError: "crm-import-error",
  importMap: (col) => `crm-import-map-${col}`,
  importMergeAll: "crm-import-merge-all",
  importSkipAll: "crm-import-skip-all",
  importRow: (i, choice) => `crm-import-row-${i}-${choice}`,
  importConsent: (key) => `crm-import-consent-${key}`, // received | permission
  importSummary: "crm-import-summary",
  importStage: "crm-import-stage",
  importStart: "crm-import-start",

  // Email Automation (§E.6)
  email: "crm-email",
  emailError: "crm-email-error",
  emailBroadcast: "crm-email-broadcast",
  emailNew: "crm-email-new",
  emailSeqGrid: "crm-email-seq-grid",
  emailSeq: (key) => `crm-email-seq-${key}`,
  emailSeqToggle: (key) => `crm-email-seq-${key}-toggle`,
  emailSeqEdit: (key) => `crm-email-seq-${key}-edit`,
  emailSeqDuplicate: (key) => `crm-email-seq-${key}-duplicate`,
  emailBirthdayToggle: "crm-email-birthday-toggle",
  emailBirthdayEdit: "crm-email-birthday-edit",
  emailBirthdayDialog: "crm-email-birthday-dialog",
  emailBirthdaySubject: "crm-email-birthday-subject",
  emailBirthdayBody: "crm-email-birthday-body",
  emailBirthdaySave: "crm-email-birthday-save",
  emailBirthdayPreview: "crm-email-birthday-preview",
  emailBirthdaySendTest: "crm-email-birthday-send-test",
  // Email preview (owner decision 2026-10-21): the rendered draft, wherever it is shown.
  emailPreviewDialog: "crm-email-preview-dialog",
  emailPreviewFrame: "crm-email-preview-frame",
  emailPreviewFrom: "crm-email-preview-from",
  emailPreviewSubject: "crm-email-preview-subject",
  emailPreviewSendTest: "crm-email-preview-send-test",
  emailDomain: "crm-email-domain",
  emailDomainStatus: "crm-email-domain-status",
  emailDomainInput: "crm-email-domain-input",
  emailDomainConnect: "crm-email-domain-connect",
  emailDomainRecord: (i) => `crm-email-domain-record-${i}`,
  emailDomainVerify: "crm-email-domain-verify",
  emailDomainDisconnect: "crm-email-domain-disconnect",

  // Broadcast composer (§E.6)
  broadcast: "crm-broadcast",
  broadcastAudience: "crm-broadcast-audience",
  broadcastSubject: "crm-broadcast-subject",
  broadcastBody: "crm-broadcast-body",
  broadcastPreview: "crm-broadcast-preview",
  broadcastPreviewPane: "crm-broadcast-preview-pane",
  broadcastSend: "crm-broadcast-send",
  broadcastSendTest: "crm-broadcast-send-test",
  broadcastConfirm: "crm-broadcast-confirm",
  broadcastConfirmCount: "crm-broadcast-confirm-count",
  broadcastConfirmSend: "crm-broadcast-confirm-send",
  broadcastConfirmCancel: "crm-broadcast-confirm-cancel",

  // Sequence editor (§E.7)
  seq: "crm-seq",
  seqError: "crm-seq-error",
  seqName: "crm-seq-name",
  seqSave: "crm-seq-save",
  seqActivate: "crm-seq-activate",
  seqTrigger: "crm-seq-trigger",
  seqTriggerParam: "crm-seq-trigger-param",
  seqTriggerPathway: "crm-seq-trigger-pathway",      // the pathway triggers' "Any pathway" / one pathway picker
  seqTriggerUnit: "crm-seq-trigger-unit",            // pathway_progress: step | level
  seqTriggerPathwayError: "crm-seq-trigger-pathway-error",
  seqStep: (i) => `crm-seq-step-${i}`,
  seqStepOffsetValue: (i) => `crm-seq-step-${i}-offset-value`,
  seqStepOffsetUnit: (i) => `crm-seq-step-${i}-offset-unit`,
  seqStepSendTest: (i) => `crm-seq-step-${i}-send-test`,
  seqStepPreview: (i) => `crm-seq-step-${i}-preview`,
  seqStepDelete: (i) => `crm-seq-step-${i}-delete`,
  seqStepDeleteDialog: (i) => `crm-seq-step-${i}-delete-dialog`,
  seqStepDeleteConfirm: (i) => `crm-seq-step-${i}-delete-confirm`,
  seqStepSubject: (i) => `crm-seq-step-${i}-subject`,
  seqStepBody: (i) => `crm-seq-step-${i}-body`,
  seqStepBookAgain: (i) => `crm-seq-step-${i}-book-again`,
  seqStepSummary: (i) => `crm-seq-step-${i}-summary`,
  seqAddStep: "crm-seq-add-step",
  seqUnsavedDialog: "crm-seq-unsaved-dialog",
  seqUnsavedLeave: "crm-seq-unsaved-leave",

  // Forms (§E.4)
  forms: "crm-forms",
  formsError: "crm-forms-error",
  formsSubmissions: "crm-forms-submissions",
  formsToggle: (field) => `crm-forms-toggle-${field}`, // phone | message | intake
  formsConsentText: "crm-forms-consent-text",
  formsCopy: "crm-forms-copy",
  formsSnippet: "crm-forms-snippet",
  formsPreview: "crm-forms-preview",
  formsPreviewDialog: "crm-forms-preview-dialog",
  formsRotateKey: "crm-forms-rotate-key",
  formsRotateKeyConfirm: "crm-forms-rotate-key-confirm",
  formsEmailVerificationNote: "crm-forms-email-verification-note",
  captureFormView: "crm-capture-form-view",

  // Packs (§E.8)
  packs: "crm-packs",
  packsError: "crm-packs-error",
  packsEmpty: "crm-packs-empty",
  packsCreate: "crm-packs-create",
  packsShowArchived: "crm-packs-show-archived",
  packsTable: "crm-packs-table",
  packsRow: (id) => `crm-packs-row-${id}`,
  packsRowEdit: (id) => `crm-packs-row-${id}-edit`,
  packsRowArchive: (id) => `crm-packs-row-${id}-archive`,
  packsRowUnarchive: (id) => `crm-packs-row-${id}-unarchive`,
  packsArchiveDialog: "crm-packs-archive-dialog",
  packsArchiveConfirm: "crm-packs-archive-confirm",
  packForm: "crm-pack-form",
  packFormName: "crm-pack-form-name",
  packFormSessions: "crm-pack-form-sessions",
  packFormPrice: "crm-pack-form-price",
  packFormValidity: "crm-pack-form-validity",
  packFormService: "crm-pack-form-service",
  packFormSave: "crm-pack-form-save",

  // Promote (P3 §E.9, lane F4): PromoteButton (mounted on course/product/profile
  // editors) + its 3-step modal.
  promote: "crm-promote",
  promoteRunning: "crm-promote-running",
  promoteStop: "crm-promote-stop",
  promoteStopDialog: "crm-promote-stop-dialog",
  promoteStopConfirm: "crm-promote-stop-confirm",
  promoteModal: "crm-promote-modal",
  promoteWhat: "crm-promote-what",
  promoteConfirm: "crm-promote-confirm",
  promoteDuration: (d) => `crm-promote-duration-${d}`,
  promoteBuyBooster: "crm-promote-buy-booster",
  promoteNext: "crm-promote-next",
  promoteBack: "crm-promote-back",
  promoteStart: "crm-promote-start",
  promoteError: "crm-promote-error",

  // Team (P3 §C3.02, lane F5): owner invite/list/resend/remove + the /admin/join accept page.
  team: "crm-team",
  teamError: "crm-team-error",
  teamOwnerRow: "crm-team-owner-row",
  teamInviteEmail: "crm-team-invite-email",
  teamInviteSubmit: "crm-team-invite-submit",
  teamRow: (id) => `crm-team-row-${id}`,
  teamRowStatus: (id) => `crm-team-row-${id}-status`,
  teamRowResend: (id) => `crm-team-row-${id}-resend`,
  teamRowRemove: (id) => `crm-team-row-${id}-remove`,
  teamRemoveDialog: "crm-team-remove-dialog",
  teamRemoveConfirm: "crm-team-remove-confirm",
  join: "crm-join",
  joinNoToken: "crm-join-no-token",
  joinSignedInAs: "crm-join-signed-in-as",
  joinMismatch: "crm-join-mismatch",
  joinMismatchSwitch: "crm-join-mismatch-switch",
  joinExpired: "crm-join-expired",
  joinError: "crm-join-error",
  joinAccepting: "crm-join-accepting",

  // Settings (CR-F3-1): the owner's CRM rules, one control per `settings.crm` field.
  settings: "crm-settings",
  settingsError: "crm-settings-error",
  settingsField: (field) => `crm-settings-${field}`,
  settingsFieldError: (field) => `crm-settings-${field}-error`,
  settingsSave: "crm-settings-save",
  settingsDiscard: "crm-settings-discard",
  seqReviewThreshold: "crm-seq-review-threshold",
});
